import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';
import './Dialog.css'

 export default function ErrorDialog(props) {

	const handleToClose = () => {
		props.setOpenErrorDialog(false);
	};
    const renderListOfUserNames = (names) => {
        return names? names.map(name => <li>{name}</li>):""
      }
	return (
		<div stlye={{}}>
			<Dialog open={props.openErrrorDialog} onClose={handleToClose}>
				<IconButton style={{cursor:'pointer',left:'92%', marginTop: '5px', width: '20px'}} onClick={handleToClose}>
				<CloseIcon />
				</IconButton>
				<DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    <div dangerouslySetInnerHTML={{ __html: props.ErrorMessage }} />
                    </DialogContentText>
                </DialogContent>
			</Dialog>
		</div>
	);
}
